function createItem(text, path, icon, items) {
  if (items) {
    items = items.sort((a, b) => a.text.localeCompare(b.text))
  }
  return {
    text,
    path,
    icon,
    items
  }
}

export default [
  createItem('Home', '/home', 'fa-solid fa-house'),
  createItem('Master', null, 'fa-solid fa-cube', [
    createItem('Barang', '/barang'),
    createItem('Foto Barang', '/foto_barang'),
    createItem('Dokumen Outlet', '/dokumen_outlet'),
    createItem('Brand', '/brand'),
    createItem('Bank', '/bank'),
    createItem('Giro', '/giro'),
    createItem('Cara Bayar', '/cara_bayar'),
    createItem('Gudang', '/gudang'),
    createItem('Jabatan', '/jabatan'),
    createItem('Pengguna', '/pengguna'),
    createItem('Jenis Barang', '/jenis_barang'),
    createItem('Jenis Dokumen Outlet', '/jenis_dokumen_outlet'),
    createItem('Jenis Harga Jual', '/jenis_harga_jual'),
    createItem('Jenis Absen', '/jenis_absen'),
    createItem('Kategori Barang', '/kategori_barang'),
    createItem('Rak', '/rak'),
    createItem('Outlet', '/outlet'),
    createItem('Jenis Pengenal', '/jenis_pengenal'),
    createItem('Sales', '/sales'),
    createItem('Status Pembayaran', '/status_bayar'),
    createItem('Status Pesanan', '/status_pesanan'),
    createItem('Tipe Outlet', '/tipe_outlet'),
    createItem('Tipe Kunjungan', '/tipe_kunjungan'),
    createItem('Provinsi', '/provinsi'),
    createItem('Kota', '/kota'),
    createItem('Kecamatan', '/kecamatan'),
    createItem('Kelurahan', '/kelurahan'),
    createItem('Kategori Akun', '/kategori_akun'),
    createItem('Akun', '/akun'),
    createItem('Supplier', '/supplier'),
  ]),
  createItem('Transaksi', null, 'fa-solid fa-star', [
    createItem('Sales Order', '/sales_order'),
    createItem('Penjualan', '/jual'),
    createItem('Piutang', '/piutang'),
    createItem('Bayar Piutang', '/bayar_piutang'),
    createItem('Absen Sales', '/absen_sales'),
    // createItem('Upload Data', '/upload_data'),
  ]),
  createItem('Import', null, 'fa-solid fa-tools', [
    createItem('Import Barang', '/import_barang'),
    createItem('Import Outlet', '/import_outlet'),
    createItem('Import Stok', '/import_stok'),
    createItem('Import Foto Barang', '/import_foto_barang'),
    createItem('Import Dokumen Outlet', '/import_dokumen_outlet'),
  ]),
  createItem('Laporan', null, 'fa-solid fa-receipt'),
  createItem('Setting', '/setting', 'fa-solid fa-gear'),
];
